module.exports = " <div class=\"field-nested field-sets\" v-el:sets> <replicator-set v-for=\"(i, set) in sets\" v-ref:sets :set=set :set-index=i :section=section :fieldtypes=fieldtypes :parent-key=parentKey @deleted=remove></replicator-set> </div> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/fieldset-builder/Sections/Sets.vue
// module id = 531
// module chunks = 0